import { createLog } from "../util/log";

/**
 *
 *
 *
 *
 */
export const log = createLog("leafcutter", "heureka.tracking");
